import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { misc } from "@/lib/misc";
import { HttpResponse, View, ViewQueryParams } from "@/types";

export function useGetViews(queryOptions: ViewQueryParams) {
  return useQuery({
    queryKey: ["views", queryOptions],
    queryFn: async () => {
      const queryParams = misc.prepareQueryParams(queryOptions);

      const path = `views?${queryParams.toString()}`;
      const res = await guacHttpClient.get<View[], HttpResponse<View[]>>(path);
      return res.data;
    },
  });
}
